import $ from 'jquery'
import Isotope from 'isotope-layout'
import imagesLoaded from 'imagesloaded'
import AirDatepicker from 'air-datepicker'
import moment from 'moment'
import initTel from '../../../js-shared/components/tel'
import Swiper from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'
import PhotoSwipeLightbox from 'photoswipe/lightbox'
import PhotoSwipe from 'photoswipe'
import PhotoSwipeDynamicCaption from 'photoswipe-dynamic-caption-plugin'
import { Loader } from '@googlemaps/js-api-loader'

// Utils.
import initFormViewer from '../../utils/init-form-viewer'
import getFormData from '../../utils/get-form-data'
import initCalendarButtons from '../../utils/init-calendar-buttons'
import initInputSpinner from '../../utils/init-input-spinner'
import initTooltips from '../../utils/init-tooltips'
import initCopyButtons from '../../utils/initCopyButtons'
import initPdfButtons from '../../utils/init-pdf-buttons'

// eslint-disable-next-line no-undef
const i18n = bookingHub

class BhubStepForm {
  /**
   * @param {jQuery} el
   */
  constructor(el) {
    this.el = el
    this.stepsEl = this.el.find('.bhub-step-booking-form__steps')
    this.stepItems = this.stepsEl.find('[data-step]')
    this.navEl = this.el.find('.bhub-wizard--header')
    this.activeStep = null
    this.activeStepEl = null
    this.prevStep = null
    this.prevStepEl = null
    this.nextStep = null
    this.nextStepEl = null
    this.bookingForm = this.el.data('form-id') * 1
    this.bookingId = this.el.data('booking-id')
    this.collect = {
      bookingForm: this.bookingForm,
      bookingId: this.bookingId,
      activeStep: '',
    }
    this.navPrevEl = el.find('button[data-action=prev]')
    this.navNextEl = el.find('button[data-action=next]')
    this.disabledDays = []
    this.firstRequest = false
    this.inited = false
    this.hoursEl = null
    this.defaultFormFieldsEl = null
    this.formViewerValid = false
    this.formValid = true
    this.loginButtonEl = null
    this.loginFormEl = null
    this.direction = 'right'
    this.origNextText = this.el.data('next-text')
    this.origPrevText = this.el.data('prev-text')
    this.origNextIcon = this.el.data('next-icon')
    this.origPrevIcon = this.el.data('prev-icon')
    this.stepsData = {}
    this.globalResponse = {}
    this.eventCounterInited = false
    this.firstStep = null
    this.getParams = {}
    this.summaryInintedOnce = false
    this.bookingType = null
    this.datepicker = {}

    this.init()
    this.el[0].bookingHub = this
  }

  formatDateByWP = (date) => {
    return moment(date).format(i18n.dateFormat)
  }

  isFormValid = () => {
    return this.formValid && this.formViewerValid
  }

  triggerFormValid = () => {
    const isValid = this.isFormValid()
    this.navNextEl.prop('disabled', !isValid)
    this.resetNextSteps()
  }

  isRentalDateValid = () => {
    const pickupLocation = this.collect.rental_date?.pickupLocation
    const dropOffLocation = this.collect.rental_date?.dropOffLocation
    const pickupDate = this.collect.rental_date?.pickupDate
    const dropOffDate = this.collect.rental_date?.dropOffDate

    return Boolean(
      pickupLocation && dropOffLocation && pickupDate && dropOffDate
    )
  }

  refreshTooltips = () => {
    initTooltips(this.el.get(0))
  }

  canNext = () => {
    switch (this.collect.activeStep) {
      case 'location':
        return Boolean(this.collect.location)
      case 'service':
        return Boolean(this.collect.service)
      case 'staff':
        return Boolean(this.collect.staff)
      case 'date':
        return Boolean(this.collect.date)
      case 'form':
        return this.isFormValid()
      case 'rental_date':
        return this.isRentalDateValid()
      case 'vehicle':
        return Boolean(this.collect.product)
      case 'extra':
        return true
      case 'room':
        return Boolean(this.collect.product)
    }
  }

  init() {
    const that = this

    const getParams = this.buildGetParams()
    this.getParams = getParams
    this.collect.getParams = getParams

    this.makeRequest()

    this.el.on('click', '[data-step-item]', function () {
      const itemEl = $(this)
      const val = itemEl.attr('data-item-value')

      if ('date' === that.collect.activeStep) {
        that.collect[that.collect.activeStep].time = val
      } else {
        that.collect[that.collect.activeStep] = val
      }

      itemEl.parent().find('[data-step-item]').removeClass('bhub-selected')
      itemEl.addClass('bhub-selected')

      that.resetNextSteps()
      that.makeRequest()
    })

    this.el.on('click', '[data-step-item] a', function (e) {
      e.stopPropagation()
    })

    this.el.on('change', 'input[name=bhub_payment_method]', function () {
      const value = $(this).val()
      that.el.find('[data-step-item=summary]').attr('data-item-value', value)
    })

    this.navPrevEl.on('click', function () {
      that.direction = 'left'
      that.goPrev()
    })

    this.navNextEl.on('click', function () {
      that.direction = 'right'
      that.goNext()
    })

    this.el.on('bookingHubResetNextSteps', () => {
      this.resetNextSteps()
    })
  }

  buildGetParams = () => {
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)

    const params = {}
    for (const [key, value] of urlParams.entries()) {
      params[key] = value
    }

    const result = {}

    Object.keys(params).forEach((key) => {
      const match = key.match(/(.*)\[(\d+)]/)
      let value = params[key]
      if (!isNaN(value)) {
        value = parseInt(value, 10)
      }

      if (match) {
        const prop = match[1]
        const index = parseInt(match[2], 10)
        if (!result[prop]) {
          result[prop] = []
        }
        result[prop][index] = value
      } else {
        result[key] = value
      }
    })

    return result
  }

  removeDuplicatedDates = (arr) => {
    const res = arr.map((date) => date.toLocaleDateString())

    return [...new Set(res)]
  }

  navErrors = {
    location: i18n.plsSelectALocation,
    service: i18n.plsSelectAService,
    date: i18n.plsSelectADate,
    time: i18n.plsSelectATime,
  }

  goNext = () => {
    if (undefined === this.nextStep) {
      this.makeRequest()
      return
    }

    if (!this.collect[this.collect.activeStep]) {
      alert(this.navErrors[this.activeStep])
      return
    }

    this.goStep(this.nextStep)
  }

  goPrev = () => {
    if (undefined === this.prevStep) return

    this.goStep(this.prevStep)
  }

  goStep(step) {
    const allSteps = this.stepsEl.find('[data-step]')
    allSteps.hide()

    this.activeStepEl = allSteps.filter(`[data-step=${step}]`)
    this.activeStep = step
    this.collect.activeStep = step

    this.nextStepEl = this.activeStepEl.next()
    this.nextStep = this.nextStepEl.data('step')

    this.prevStepEl = this.activeStepEl.prev()
    this.prevStep = this.prevStepEl.data('step')

    this.navPrevEl.prop('disabled', !this.prevStep)
    // this.navNextEl.prop('disabled', !this.nextStep)
    this.navNextEl.prop('disabled', !this.canNext())

    this.activeStepEl.show()

    const currentNavStep = this.navEl.find(`[data-step=${step}]`)
    const prevNavSteps = currentNavStep.prevAll()
    const nextNavSteps = currentNavStep.nextAll()
    const wrapper = currentNavStep.parent()

    currentNavStep.addClass('bhub-active')
    currentNavStep.removeClass('bhub-wait bhub-completed')

    prevNavSteps.removeClass('bhub-wait bhub-active')
    prevNavSteps.addClass('bhub-completed')

    nextNavSteps.removeClass('bhub-completed')
    nextNavSteps.addClass('bhub-wait')

    let activeItem = wrapper.find('.bhub-wizard--header-item.bhub-active')
    if (activeItem?.offset()?.left) {
      let scrollLeftValue =
        activeItem.offset().left - wrapper.offset().left + wrapper.scrollLeft()
      if (wrapper.hasClass('bhub-wizard--header-style-2')) {
        wrapper.animate(
          {
            'padding-inline-start':
              (wrapper.find('.bhub-wizard--header-item--title').width() - 30) /
              2,
            'padding-inline-end':
              (wrapper.find('.bhub-wizard--header-item--title:last').width() -
                30) /
              2,
          },
          100
        )
        scrollLeftValue = scrollLeftValue - 50
      }
      wrapper.animate(
        {
          scrollLeft: scrollLeftValue,
        },
        'slow'
      )
    }

    if (this.stepsData[step]?.nextButtonText) {
      this.navNextEl.text(this.stepsData[step].nextButtonText)
    } else {
      this.navNextEl.text(this.origNextText)
    }

    if (step === 'service') {
      this.initServiceCategoryFilter()
    }

    if (step === 'summary') {
      this.navNextEl.prop('disabled', false)
    }

    if (step === 'payment') {
      this.navNextEl.hide()
    } else {
      this.navNextEl.show()
    }

    if (this.collect.activeStep === 'success') {
      this.initSuccess()
    }

    if (this.inited) {
      this.activeStepEl.removeClass('bhub-fade-in-right bhub-fade-in-left')
      this.activeStepEl.addClass(`bhub-fade-in-${this.direction}`)
      this.el[0].scrollIntoView({ behavior: 'smooth' })
    }

    this.inited = true

    window.dispatchEvent(
      new CustomEvent('bookingHubStepTransition', {
        detail: {
          instance: this,
          mainEl: this.el[0],
          bookingId: this.bookingId,
          step,
        },
      })
    )
  }

  resetNextSteps = () => {
    const that = this
    const nextSteps = this.activeStepEl.nextAll()
    nextSteps.each(function () {
      const nextStepEl = $(this)
      const step = nextStepEl.data('step')
      that.collect[step] = undefined
    })
    nextSteps.remove()
    this.nextStep = undefined
  }

  resetAllSteps = () => {
    this.stepsEl.html('')
  }

  getYmd = (month, year) => {
    const date = new Date()

    date.setFullYear(year, month, 1)

    const formattedYear = date.getFullYear()
    const formattedMonth = ('0' + (date.getMonth() + 1)).slice(-2)
    const formattedDay = '01'

    return formattedYear + '-' + formattedMonth + '-' + formattedDay
  }

  formatDate = (date) => {
    let month = '' + (date.getMonth() + 1)
    let day = '' + date.getDate()
    let year = date.getFullYear()

    if (month.length < 2) month = '0' + month
    if (day.length < 2) day = '0' + day

    return [year, month, day].join('-')
  }

  login = () => {
    const that = this

    $.dialog({
      theme: 'bhub-modal',
      closeIcon: true,
      draggable: false,
      backgroundDismiss: true,
      animateFromElement: true,
      animationSpeed: 300,
      animation: 'scale',
      closeAnimation: 'scale',
      columnClass: 'bhub-small bhub-login-modal-form',
      content: function () {
        const self = this
        return $.ajax({
          method: 'POST',
          url: i18n.ajaxUrl,
          data: {
            action: 'bhub_get_login_form',
            _ajax_nonce: i18n.nonce,
          },
        })
          .done(function (response) {
            self.setTitle(response.data.title)
            self.setContent(response.data.content)
          })
          .fail(function () {
            self.setContent(i18n.wrongMessage)
          })
      },
      onContentReady: function () {
        const modal = this
        const form = this.$content.find('form')
        this.loginFormEl = form
        this.loginFormEl.validate()
        this.loginFormEl.on('submit', function (e) {
          if (!$(this).valid()) return

          e.preventDefault()

          $.ajax({
            method: 'POST',
            url: i18n.ajaxUrl,
            data: $(this).serialize() + '&action=bhub_handle_login_form',
            beforeSend: () => {
              $(this).bhubRemoveAlert()
            },
            success: (res) => {
              if (!res.success) {
                $(this).bhubAddAlert(res.data.message, 'error')
              } else {
                i18n.nonce = res.data.loginNonce

                const defaultForm = that.defaultFormFieldsEl
                const userData = res.data.userData
                if (Object.keys(userData).length > 0) {
                  Object.keys(userData).forEach((key) => {
                    const field = defaultForm.find(`[name="${key}"]`)
                    if (field) {
                      field.val(userData[key]).trigger('keyup')
                    }
                  })
                }

                that.loginButtonEl.remove()
                modal.close()
              }
            },
            error: () => {
              $(this).bhubAddAlert(i18n.wrongMessage)
            },
          })
        })
      },
    })
  }

  initFormFields = (stepEl) => {
    const loginButton = stepEl.find('[data-button=login]')

    this.defaultFormFieldsEl = stepEl.find('.bhub-default-form-fields')
    this.defaultFormFieldsEl.validate({
      onkeyup: function (element) {
        $(element).valid()
      },
      onfocusout: function (element) {
        $(element).valid()
      },
    })
    this.formValid = this.defaultFormFieldsEl[0].checkValidity()
    this.triggerFormValid()
    this.collect.defaultForm = getFormData(this.defaultFormFieldsEl)

    const tel = this.defaultFormFieldsEl.find('input[type=tel]')
    if (tel.length) {
      initTel(tel.get(0))
    }

    if (loginButton.length > 0) {
      this.loginButtonEl = loginButton
      this.loginButtonEl.on('click', this.login)
    }

    const handleChange = () => {
      this.formValid = this.defaultFormFieldsEl[0].checkValidity()
      this.triggerFormValid()
      this.collect.defaultForm = getFormData(this.defaultFormFieldsEl)
    }

    this.defaultFormFieldsEl
      .find('input:not([type="checkbox"]), textarea')
      .on('keyup', () => handleChange())

    this.defaultFormFieldsEl.find('input[type=checkbox]').on('change', (e) => {
      $(e.target).valid()
      handleChange()
    })

    const userDefinedForm = stepEl.find('.bhub-form-viewer')
    if (userDefinedForm.length) {
      initFormViewer(userDefinedForm.get(0)).then((form) => {
        form._state.schema.components.forEach((component) => {
          const isPhone = component?.validate?.validationType === 'phone'
          if (isPhone) {
            const tel = this.activeStepEl.find(`input[id*='${component.id}']`)
            initTel(tel.get(0))
          }
        })
        form.validate()
        form.on('changed', (event) => {
          const { data, errors } = event
          const isValid = Object.keys(errors).length === 0
          this.formViewerValid = isValid
          this.triggerFormValid()
          this.collect[this.collect.activeStep] = data
        })
      })
    } else {
      this.formViewerValid = true
      this.collect[this.collect.activeStep] = {}
    }
  }

  initTimeSlot = (stepEl) => {
    const calendarEL = stepEl.find('.bhub-date-select__calendar')
    const hoursInfoEL = stepEl.find('.bhub-date-select__hours-info')
    const that = this
    const formattedDays = this.disabledDays.map((date) => {
      return new Date(date)
    })

    this.datepicker = new AirDatepicker(calendarEL[0], {
      classes: 'bhub-airdatepicker',
      locale: i18n.calendar.i18n,
      dateFormat: 'yyyy-MM-dd',
      firstDay: i18n.firstDayOfTheWeek * 1,
      toggleSelected: false,
      showOtherMonths: false,
      selectOtherMonths: false,
      fixedHeight: true,
      minDate: new Date(),
      onRenderCell: ({ date, cellType, datepicker }) => {
        if ('day' !== cellType) return
        if (date.getMonth() !== datepicker.viewDate.getMonth()) return

        const isDisabled = formattedDays.some(
          (disabledDate) =>
            date.toLocaleDateString() === disabledDate.toLocaleDateString()
        )

        if (isDisabled) {
          return {
            disabled: true,
          }
        }
      },
      onChangeViewDate: ({ month, year }) => {
        this.datepicker.clear()
        this.hoursEl.html('')
        hoursInfoEL.text(i18n.selectDate)
        const ymd = that.getYmd(month, year)

        $(this.datepicker.$datepicker).bhubBlock()
        this.getDisabledDays(ymd)
          .then((disabledDays) => {
            this.datepicker.disableDate(disabledDays)
            that.disabledDays = disabledDays
          })
          .catch((err) => {
            alert(err)
          })
          .finally(() => {
            $(this.datepicker.$datepicker).bhubUnBlock()
          })
      },
      onSelect: ({ formattedDate, datepicker, date }) => {
        this.resetNextSteps()
        this.navNextEl.prop('disabled', true)

        if (!date) return
        if (datepicker.isDateDisabled(date)) return

        that.firstRequest = true

        this.collect.date = { date: [formattedDate] }
        hoursInfoEL.text(this.formatDateByWP(formattedDate, i18n.dateFormat))

        $.ajax({
          url: i18n.ajaxUrl,
          method: 'POST',
          dataType: 'json',
          data: {
            action: 'bhub/templates/form/step/get_hours',
            _ajax_nonce: i18n.nonce,
            collect: JSON.stringify(this.collect),
            date: formattedDate,
          },
          success: (res) => {
            const { data, success } = res

            if (success) {
              stepEl.find('.bhub-date-select__hours').html(data.template)
            }
          },
        })
      },
      buttons: [
        {
          content() {
            return i18n.todayStr
          },
          onClick(datepicker) {
            const today = new Date()
            const disabled = datepicker.isDateDisabled(today)

            if (disabled) {
              datepicker.setViewDate(new Date())
            } else {
              datepicker.selectDate(today)
            }
          },
        },
      ],
    })

    this.collect.date = { date: this.formatDate(new Date()) }
  }

  isDisabledDateIsInRange = (date, datepicker, argDisabledDays) => {
    const disabledDays = argDisabledDays ?? this.disabledDays
    const selectedDate = datepicker.selectedDates[0]

    if (selectedDate && datepicker.selectedDates.length === 1) {
      const sortedDates = [selectedDate, date].toSorted((a, b) => {
        if (a.getTime() > b.getTime()) {
          return 1
        }
        return -1
      })

      return disabledDays.some((disabledDate) => {
        return moment(disabledDate).isBetween(sortedDates[0], sortedDates[1])
      })
    }
  }

  isOutOfLimit = (date, datepicker) => {
    const selectedDate = datepicker.selectedDates[0]
    const { minAllowedDays, maxAllowedDays } = this.globalResponse

    if (minAllowedDays === 0 && maxAllowedDays === 0) {
      return false
    }

    if (selectedDate && datepicker.selectedDates.length === 1) {
      const diff = moment(date).diff(selectedDate, 'days')

      if (minAllowedDays === 0 && maxAllowedDays > 0) {
        return diff > maxAllowedDays
      }

      if (maxAllowedDays === 0 && minAllowedDays > 0) {
        return diff < minAllowedDays
      }

      return diff < minAllowedDays || diff > maxAllowedDays
    }

    return false
  }

  initDays = (stepEl, initialDisabledDays = []) => {
    const calendarEL = stepEl.find('.bhub-day-select__calendar')
    const that = this
    const useDisabledDays =
      this.disabledDays.length > 0 ? this.disabledDays : initialDisabledDays
    const formattedDays = useDisabledDays.map((date) => {
      return new Date(date)
    })
    this.disabledDays = useDisabledDays
    const { maxDistance } = this.globalResponse
    const maxDate =
      maxDistance > 0
        ? moment().add(maxDistance, 'days').format('YYYY-MM-DD')
        : 0

    const airInstance = (this.datepicker = new AirDatepicker(calendarEL[0], {
      classes: 'bhub-airdatepicker',
      locale: i18n.calendar.i18n,
      firstDay: i18n.firstDayOfTheWeek * 1,
      range: true,
      toggleSelected: false,
      dynamicRange: false,
      showOtherMonths: false,
      selectOtherMonths: false,
      fixedHeight: true,
      minDate: new Date(),
      maxDate,
      dateFormat: 'yyyy-MM-dd',
      onSelect: ({ formattedDate, datepicker }) => {
        if (formattedDate.length !== 2) return

        const selected = this.removeDuplicatedDates(datepicker.selectedDates)
        if (selected.length < 2) {
          datepicker.clear()
          this.resetNextSteps()
          this.navNextEl.prop('disabled', true)
          return
        }

        this.collect.date = { date: formattedDate }
        this.navNextEl.prop('disabled', false)
        this.resetNextSteps()
        datepicker.trigger('select', { formattedDate })
      },
      onBeforeSelect: ({ date, datepicker }) => {
        if (that.isDisabledDateIsInRange(date, datepicker)) {
          return false
        }

        if (this.isOutOfLimit(date, datepicker)) {
          return false
        }

        return true
      },
      onFocus: ({ date, datepicker }) => {
        if (
          that.isDisabledDateIsInRange(date, datepicker) ||
          that.isOutOfLimit(date, datepicker)
        ) {
          datepicker.$datepicker.classList.add('-disabled-range-')
        } else {
          datepicker.$datepicker.classList.remove('-disabled-range-')
        }
      },
      onRenderCell: ({ date }) => {
        const isDateInFormattedDays = formattedDays.some(
          (disabledDates) =>
            date.toLocaleDateString() === disabledDates.toLocaleDateString()
        )

        if (isDateInFormattedDays) {
          return {
            disabled: true,
          }
        }
      },
      onChangeViewDate: ({ month, year }) => {
        const ymd = that.getYmd(month, year)

        $(airInstance.$datepicker).bhubBlock()
        this.getDisabledDays(ymd)
          .then((disabledDays) => {
            airInstance.disableDate(disabledDays)
            const setDisabledDays = disabledDays.map((date) => {
              return new Date(date)
            })
            that.disabledDays = setDisabledDays
          })
          .catch((err) => {
            alert(err)
          })
          .finally(() => {
            $(airInstance.$datepicker).bhubUnBlock()
          })
      },
      buttons: [
        {
          content() {
            return i18n.todayStr
          },
          onClick(datepicker) {
            datepicker.setViewDate(new Date())
          },
        },
        {
          content() {
            return i18n.clear
          },
          onClick(datepicker) {
            datepicker.clear({ silent: true })
            datepicker.setViewDate(new Date())
            that.resetNextSteps()
            that.navNextEl.prop('disabled', true)
          },
        },
      ],
    }))
  }

  request() {
    const that = this
    return new Promise((resolve, reject) => {
      $.ajax({
        url: i18n.ajaxUrl,
        method: 'POST',
        dataType: 'json',
        data: {
          action: 'bhub/templates/form/step/middleware',
          _ajax_nonce: i18n.nonce,
          collect: JSON.stringify(this.collect),
        },
        beforeSend: () => {
          that.el.bhubBlock()
        },
        success: (res) => {
          if (res.success) {
            resolve(res.data)
          } else {
            reject(res.data)
          }
        },
        complete: () => {
          that.el.bhubUnBlock()
        },
      })
    })
  }

  makeRequest() {
    this.request()
      .then((data) => {
        if (data.redirect) {
          window.location.href = data.redirect
          return
        }

        this.stepsEl.append(data.template)
        this.collect.activeStep = data.activeStep

        if (!this.firstStep) {
          this.firstStep = data.activeStep
        }

        this.refreshTooltips()

        if (data.customNextText) {
          if (!this.stepsData[this.collect.activeStep]) {
            this.stepsData[this.collect.activeStep] = {}
          }

          this.stepsData[this.collect.activeStep].nextButtonText =
            data.customNextText
        }

        this.globalResponse = data.globalResponse
        this.bookingType = data.globalResponse.bookingType

        this.direction = 'right'
        this.goStep(data.activeStep)
        this.resetNextSteps()

        if (
          this.collect.activeStep === 'date' &&
          data?.bookingType === 'hotel'
        ) {
          this.initHotelGuestSelection()
          this.initDays(
            this.stepsEl.find('[data-step=date]'),
            data.disabledDays,
            data.minAllowedDays,
            data.maxAllowedDays
          )
        }

        if (
          this.collect.activeStep === 'date' &&
          data?.bookingType === 'time'
        ) {
          this.disabledDays = data.disabledDays
          this.initTimeSlot(this.stepsEl.find('[data-step=date]'))
          this.hoursEl = this.activeStepEl.find('.bhub-date-select__hours')
        }

        if (this.collect.activeStep === 'form') {
          this.initFormFields(this.stepsEl.find('[data-step=form]'))
        }

        if (this.collect.activeStep === 'service') {
          this.initServiceCategoryFilter()
        }

        if (this.collect.activeStep === 'room') {
          this.initHotelRooms()
        }

        if (
          this.collect.activeStep === 'date' &&
          data?.bookingType === 'rent'
        ) {
          this.initRentalDate()
        }

        if (this.collect.activeStep === 'vehicle') {
          this.initVehicle()
        }

        if (this.collect.activeStep === 'summary') {
          this.initSummary()
        }

        if (this.collect.activeStep === 'extra') {
          this.initExtra()
        }

        if (this.collect.activeStep === 'payment') {
          const event = new CustomEvent('bookingHubPaymentStep', {
            detail: {
              mainEl: this.el[0],
              submit: this.submit,
              bookingId: this.bookingId,
              bookingForm: this.bookingForm,
              paymentMethod: this.collect.summary,
            },
          })

          window.dispatchEvent(event)
        }

        if (this.globalResponse.bookingType === 'event') {
          if (this.globalResponse.ticketCounter && !this.eventCounterInited) {
            this.eventCounterInited = true
            const {
              allowedCount,
              bookedCount,
              percentStr,
              purchasedStr,
              totalStr,
            } = this.globalResponse.ticketCounter
            let prepend = `<div class="bhub-event-counter"><div class="bhub-event-counter__top">`
            prepend += `<span class="bhub-event-counter__percent">${percentStr}</span>`
            prepend += `<span class="bhub-event-counter__purchased"><span></span>${purchasedStr}</span>`
            prepend += `<span class="bhub-event-counter__total"><span></span>${totalStr}</span>`
            prepend += `</div><div class="bhub-event-counter__bottom">`
            prepend += `<span class="bhub-event-counter__indicator" style="width: ${(bookedCount * 100) / allowedCount}%"></span>`
            prepend += '</div></div>'
            this.el.find('.bhub-step-booking-form__navigation').prepend(prepend)
          }
        }

        if (
          this.globalResponse?.coupons?.enabled &&
          this.collect.activeStep === 'summary'
        ) {
          const that = this

          this.el.on('click', '.bhub-coupon-toggle', function (e) {
            e.preventDefault()
            $(this).closest('.bhub-form-field').find('.bhub-coupon-form__wrapper').show()
          })

          this.el.on('click', '.bhub-active-coupons__remove', function (e) {
            e.preventDefault()
            e.stopPropagation()

            $.ajax({
              url: i18n.ajaxUrl,
              method: 'POST',
              dataType: 'json',
              data: {
                _ajax_nonce: i18n.nonce,
                booking_id: $(this).data('booking-id'),
                collect: JSON.stringify(that.collect),
                action: 'bhub/coupons/remove',
              },
              beforeSend: () => {
                that.el.find('.bhub-coupons').bhubBlock()
              },
              success: (res) => {
                const { data, success } = res

                if (success) {
                  that.el
                    .find('.bhub-payment-table')
                    .replaceWith(data.paymentTable)
                  that.el.find('.bhub-coupons').replaceWith(data.couponTemplate)
                  if (data.depositSelection) {
                    that.el
                      .find('.bhub-deposit-payment-selection')
                      .replaceWith(data.depositSelection)
                  }
                }
              },
              complete: () => {
                that.el.find('.bhub-coupons').bhubUnBlock()
              },
            })
          })
          // prevent multiple submission
          if (!that.summaryInintedOnce) {
            this.el.on('submit', '.bhub-coupon-form', function (e) {
              e.preventDefault()
              e.stopPropagation()

              $.ajax({
                url: i18n.ajaxUrl,
                method: 'POST',
                dataType: 'json',
                data: [
                  $(this).serialize(),
                  $.param({
                    _ajax_nonce: i18n.nonce,
                    collect: JSON.stringify(that.collect),
                    action: 'bhub/coupons/add',
                  }),
                ].join('&'),
                beforeSend: () => {
                  $(this).find('.bhub-coupon-form__error').remove()
                  that.el.find('.bhub-coupons').bhubBlock()
                  that.summaryInintedOnce = true
                },
                success: (res) => {
                  const { data, success } = res

                  if (success) {
                    that.el
                      .find('.bhub-payment-table')
                      .replaceWith(data.paymentTable)
                    that.el
                      .find('.bhub-coupons')
                      .replaceWith(data.couponTemplate)
                    if (data.depositSelection) {
                      that.el
                        .find('.bhub-deposit-payment-selection')
                        .replaceWith(data.depositSelection)
                    }
                    that.refreshTooltips()
                  } else {
                    $(this).append(
                      `<span class="bhub-coupon-form__error">${data.message}</span>`
                    )
                  }
                },
                complete: () => {
                  that.el.find('.bhub-coupons').bhubUnBlock()
                },
              })
            })
          }
        }
      })
      .catch((err) => {
        alert(err?.message ?? 'error!')
      })
  }

  getDisabledDays = (ymd) => {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: i18n.ajaxUrl,
        method: 'POST',
        dataType: 'json',
        data: {
          action: 'bhub/templates/form/step/get_disabled_days',
          _ajax_nonce: i18n.nonce,
          collect: JSON.stringify(this.collect),
          date: ymd,
        },
        success: (res) => {
          const { data, success } = res

          if (success) {
            resolve(data.disabledDays)
          } else {
            reject(data.message)
          }
        },
      })
    })
  }

  initServiceCategoryFilter = () => {
    const parent = this.activeStepEl.find('.bhub-service-selection__services')

    if (!parent.length) {
      return
    }

    const instance = Isotope.data(parent[0])
    if (instance) {
      instance.layout()
      return
    }

    const filterItems = this.activeStepEl.find('.bhub-feed-service-category')

    imagesLoaded(parent[0], () => {
      this.serviceIsotope = new Isotope(parent[0], {
        itemSelector: '.bhub-service-item',
        percentPosition: true,
        masonry: {
          columnWidth: '.bhub-service-selection__sizer',
        },
      })
    })

    filterItems.on('click', (e) => {
      const $this = $(e.currentTarget)
      const val = $this.data('value') * 1

      filterItems.removeClass('bhub-active')
      $this.addClass('bhub-active')

      if (!this.serviceIsotope) return

      if (!val) {
        this.serviceIsotope.arrange({ filter: '*' })
        return
      }

      this.serviceIsotope.arrange({
        filter: function () {
          const attr = $(this).attr('data-categories')
          const categories = attr.includes(',') ? attr.split(',') : [attr]
          const newCategories = categories.map(Number)

          return newCategories.includes(val)
        },
      })
    })

    if (!this.serviceIsotopeResizeBound) {
      this.serviceIsotopeResizeBound = true
      $(window).on('resize.bhubServiceIsotope', () => {
        clearTimeout(this.serviceIsotopeResizeTimer)
        this.serviceIsotopeResizeTimer = setTimeout(() => {
          if (this.serviceIsotope) {
            this.serviceIsotope.layout()
          }
        }, 150)
      })
    }
  }

  initSummary = () => {
    const that = this
    const summaryEl = this.activeStepEl.find('.bhub-booking-summary')
    const paymentMethods = summaryEl.find('input[name=bhub_payment_method]')
    const activeMethod = paymentMethods.filter(':checked').val()
    this.collect[that.collect.activeStep] = activeMethod

    paymentMethods.on('change', function () {
      that.resetNextSteps()
      const selectedMethod = $(this).val()
      that.collect[that.collect.activeStep] = selectedMethod
    })

    if (activeMethod) {
      this.navNextEl.prop('disabled', false)
    }
  }

  reset = (bookingId) => {
    this.bookingId = bookingId
    this.el.attr('data-booking-id', bookingId)
    this.collect = {
      bookingForm: this.bookingForm,
      bookingId: this.bookingId,
      activeStep: '',
    }
    this.el.find('.bhub-step-booking-form__navigation').show()
    this.resetAllSteps()
    this.makeRequest()
  }

  initSuccess = () => {
    const that = this
    this.el.find('.bhub-step-booking-form__navigation').hide()
    initCopyButtons(this.el.get(0))
    initPdfButtons(this.el.get(0))

    initCalendarButtons(this.el.get(0)).then(() => {
      this.refreshTooltips()
    })

    const resetButton = this.el.find('[data-bhub-reset]')
    if (resetButton.length) {
      resetButton.on('click', () => {
        $.ajax({
          method: 'POST',
          url: i18n.ajaxUrl,
          data: {
            action: 'bhub/templates/form/step/generate_booking_form_id',
            _ajax_nonce: i18n.nonce,
          },
          beforeSend: () => {
            this.el.bhubBlock()
          },
          success: (res) => {
            if (res.success) {
              that.reset(res.data.bookingId)
            }
          },
          complete: () => {
            this.el.bhubUnBlock()
          },
        })
      })
    }
  }

  initHotelGuestSelection = () => {
    const childrenSelect = this.activeStepEl.find('select[name=children]')
    const adultSelect = this.activeStepEl.find('select[name=adult]')
    const agesWrapper = this.activeStepEl.find(
      '.bhub-guest-selection__children-ages'
    )
    const cloneItem = this.activeStepEl.find('[data-default]')

    const getVals = () => {
      return {
        adult: adultSelect.val(),
        children: childrenSelect.val(),
        childrenAges: this.activeStepEl
          .find('select[name="child_age[]"]')
          .filter(function () {
            return !$(this).prop('disabled')
          })
          .map(function () {
            return $(this).val()
          })
          .get(),
      }
    }

    this.collect.hotelGuest = getVals()

    $(document).on('change', this.activeStepEl.find('select'), () => {
      this.resetNextSteps()
      this.collect.hotelGuest = getVals()
    })

    childrenSelect.on('change', function () {
      const val = $(this).val() * 1
      agesWrapper.find('[data-clone]').remove()

      if (!val) {
        agesWrapper.hide()
        cloneItem.find('select').prop('disabled', true)
        return
      }

      cloneItem.find('select').prop('disabled', false)
      if (val > 1) {
        for (var i = 0; i < val - 1; i++) {
          const clone = cloneItem.clone()

          clone.removeAttr('data-default')
          clone.attr('data-clone', '')

          clone.appendTo(agesWrapper)
        }
      }

      agesWrapper.show()
    })
  }

  selectRoom = (roomEl) => {
    if ((!roomEl) instanceof $) {
      roomEl = this.activeStepEl.find(
        `.bhub-feed-hotel-room[data-room=${roomEl}]`
      )
    }

    const roomId = roomEl.attr('data-room') * 1
    const rooms = this.activeStepEl.find('[data-room]')
    rooms.removeClass('bhub-selected')
    roomEl.addClass('bhub-selected')
    this.collect.product = roomId
    this.collect.room = roomId
    this.navNextEl.prop('disabled', false)
  }

  unSelectRoom = (roomEL) => {
    if ((!roomEL) instanceof $) {
      roomEL = this.activeStepEl.find(
        `.bhub-feed-hotel-room[data-room=${roomEL}]`
      )
    }

    roomEL.removeClass('bhub-selected')
    this.navNextEl.prop('disabled', true)
    this.resetNextSteps()
    this.collect.product = 0
    this.collect.room = 0
  }

  callRoomDetail = (roomId) => {
    const that = this

    return new Promise((resolve, reject) => {
      $.confirm({
        theme: 'bhub-drawer bhub-room-detail-drawer',
        closeIcon: true,
        closeIconClass: 'bhub-icons-close',
        draggable: false,
        backgroundDismiss: true,
        animateFromElement: false,
        animationSpeed: 300,
        animation: 'right',
        closeAnimation: 'right',
        useBootstrap: false,
        content: function () {
          var self = this
          return $.ajax({
            url: i18n.ajaxUrl,
            method: 'POST',
            dataType: 'json',
            data: {
              action: 'bhub_get_room_detail',
              _ajax_nonce: i18n.nonce,
              roomId,
              ...that.collect,
            },
          })
            .done(function (response) {
              const content = $(response.data.template)
              self.setContent(content)
              self.setTitle(response.data.title)
              resolve(content)
            })
            .fail(function () {
              self.setContent('Something went wrong.')
              reject()
            })
        },
        buttons: {
          select: {
            text: `<i class="bhub-icons-angle-left"></i>${i18n.i18n.select}`,
            btnClass: 'bhub-button bhub-tp-stepper-button',
            action: function () {
              that.selectRoom(
                that.activeStepEl.find(
                  `.bhub-feed-hotel-room[data-room=${roomId}]`
                )
              )
            },
          },
        },
        onContentReady: function () {
          that.initRoomGallery(this.$content.find('.bhub-room-detail'))
        },
      })
    })
  }

  initHotelRooms = () => {
    const that = this
    const rooms = this.activeStepEl.find('[data-room]')
    const detailBtn = this.activeStepEl.find(
      '.bhub-feed-hotel-room__see-detail'
    )
    const detailWrapper = this.activeStepEl.find(
      '.bhub-room-selection__pool-view'
    )
    let requesting = false

    detailWrapper.on('click', '.bhub-room-detail__closer', function () {
      rooms.removeClass('bhub-selected')
      detailWrapper.html('')
      that.navNextEl.prop('disabled', true)
      that.resetNextSteps()
    })

    rooms.on('click', function () {
      const room = $(this)

      if (room.hasClass('bhub-selected')) {
        that.unSelectRoom(room)
        return
      }

      that.selectRoom(room)
    })

    detailBtn.on('click', function (e) {
      e.stopPropagation()
      if (requesting) return
      const room = $(this).closest('.bhub-feed-hotel-room')
      const roomId = room.data('room') * 1
      that.callRoomDetail(roomId).finally(() => {
        requesting = false
      })
    })
  }

  initRoomGallery = (el) => {
    const galleryWrapper = el.find('.bhub-room-detail__gallery')
    const sliderWrapper = el.find('.bhub-room-detail__section--gallery')

    galleryWrapper.find('a').each(function () {
      // Disable Elementor's lightbox.
      $(this).get(0).dataset.elementorOpenLightbox = 'no'
    })

    const lightbox = new PhotoSwipeLightbox({
      gallery: galleryWrapper.get(0),
      children: 'a',
      pswpModule: PhotoSwipe,
    })

    new PhotoSwipeDynamicCaption(lightbox, {
      type: 'auto',
      captionContent: (slide) => {
        return slide.data.element.getAttribute('data-caption')
      },
    })

    lightbox.init()

    const swiper = new Swiper(sliderWrapper.get(0), {
      modules: [Navigation, Pagination],
      spaceBetween: 15,
      pagination: {
        el: el.find('.bhub-room-detail__pag').get(0),
      },
      navigation: {
        nextEl: el.find('.bhub-room-detail__next').get(0),
        prevEl: el.find('.bhub-room-detail__prev').get(0),
      },
      loop: true,
    })

    lightbox.on('change', () => {
      swiper.slideTo(lightbox.pswp.currIndex)
    })
  }

  /**
   * @param {HTMLInputElement} inputEl
   */
  initAutocomplete = (inputEl) => {
    return new window.google.maps.places.Autocomplete(inputEl)
  }

  /**
   * @param {HTMLInputElement} inputEl
   */
  initDateTimePicker = (inputEl, args = {}) => {
    const datepicker = new AirDatepicker(inputEl, {
      classes: 'bhub-airdatepicker',
      locale: i18n.calendar.i18n,
      firstDay: i18n.firstDayOfTheWeek * 1,
      autoClose: true,
      toggleSelected: false,
      showOtherMonths: false,
      selectOtherMonths: false,
      minDate: new Date(),
      dateFormat: 'yyyy-MM-dd',
      timepicker: true,
      ...args,
      timeFormat: i18n.timeFormat.toLowerCase().includes('a')
        ? 'hh:mm AA'
        : 'HH:mm',
      onSelect: ({ datepicker }) => {
        $(datepicker.$el).trigger('change')
      },
      buttons: [
        {
          content() {
            return i18n.todayStr
          },
          onClick(datepicker) {
            datepicker.selectDate(new Date())
          },
        },
      ],
    })

    const pickerButtons = datepicker?.$buttons?.querySelectorAll('button')
    if (pickerButtons && pickerButtons.length) {
      pickerButtons.forEach((button) => {
        button.setAttribute('type', 'button')
      })
    }

    return datepicker
  }

  initRentalDate = () => {
    const pickupLocation = this.activeStepEl.find('input[name=pickup_location]')
    const dropOffLocation = this.activeStepEl.find(
      'input[name=drop_off_location]'
    )

    const pickupDate = this.activeStepEl.find('input[name=pickup_date]')
    const dropOffDate = this.activeStepEl.find('input[name=drop_off_date]')

    const today = new Date()

    const tomorrow = new Date(today)
    tomorrow.setHours(12)
    tomorrow.setMinutes(0)
    tomorrow.setDate(today.getDate() + 1)

    const twoDays = new Date(today)
    twoDays.setHours(12)
    twoDays.setMinutes(0)
    twoDays.setDate(today.getDate() + 2)

    this.pickupDatepicker = this.initDateTimePicker(pickupDate[0], {
      minutesStep: 15,
      selectedDates: tomorrow,
    })
    this.dropOffDatepicker = this.initDateTimePicker(dropOffDate[0], {
      minutesStep: 15,
      selectedDates: twoDays,
    })

    pickupDate.on('change', () => {
      // dropOffDate.focus()
    })

    const collectData = () => {
      this.resetNextSteps()

      this.collect.rental_date = {
        pickupLocation: pickupLocation.val(),
        dropOffLocation: dropOffLocation.val(),
        pickupDate: pickupDate.val(),
        dropOffDate: dropOffDate.val(),
      }

      this.collect.date = { date: [pickupDate.val(), dropOffDate.val()] }

      const valid =
        pickupLocation.val() &&
        dropOffLocation.val() &&
        pickupDate.val() &&
        dropOffDate.val()

      this.navNextEl.prop('disabled', !valid)
    }

    if (i18n.google.map.enabled) {
      const loader = new Loader({
        apiKey: i18n.google.map.apiKey,
        version: 'weekly',
        libraries: ['places'],
      })

      loader.importLibrary('maps').then(() => {
        const ac1 = this.initAutocomplete(pickupLocation[0])
        const ac2 = this.initAutocomplete(dropOffLocation[0])

        window.google.maps.event.addListener(
          ac1,
          'place_changed',
          () => collectData
        )

        window.google.maps.event.addListener(
          ac2,
          'place_changed',
          () => collectData
        )
      })
    }

    this.activeStepEl.find('input').on('change', () => collectData())
  }

  initVehicle = () => {
    const that = this
    const vehicles = this.activeStepEl.find('[data-vehicle]')

    vehicles.on('click', function () {
      that.resetNextSteps()
      const vehicle = $(this)

      if (vehicle.hasClass('bhub-selected')) {
        vehicle.removeClass('bhub-selected')
        that.navNextEl.prop('disabled', true)
        that.collect.product = 0
        that.collect.vehicle = 0
        return
      }

      const vehicleId = vehicle.data('vehicle') * 1
      that.navNextEl.prop('disabled', false)
      vehicles.removeClass('bhub-selected')
      vehicle.addClass('bhub-selected')
      that.collect.product = vehicleId
      that.collect.vehicle = vehicleId
      that.goNext()
    })
  }

  initExtra = () => {
    const that = this
    this.collect.extra = {}
    const extras = {}

    const inputSpinners = this.activeStepEl.find('.bhub-input-spinner__input')
    inputSpinners.each(function () {
      initInputSpinner($(this)[0])
    })

    inputSpinners.on('change', function () {
      that.resetNextSteps()
      const cur = $(this)
      const id = cur.attr('name') * 1
      const value = cur.val() * 1
      if (value > 0) {
        extras[id] = value
      } else {
        delete extras[id]
      }
      that.collect.extra = extras
    })

    const addButtons = this.activeStepEl.find('.bhub-extra-item__add-button')
    addButtons.on('click', function () {
      that.resetNextSteps()
      const cur = $(this)
      cur.toggleClass('bhub-has-remove')
      const extraId = cur.data('product-id') * 1
      if (cur.hasClass('bhub-has-remove')) {
        extras[extraId] = 1
      } else {
        delete extras[extraId]
      }
      that.collect.extra = extras
    })
  }

  submit = (data = []) => {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: i18n.ajaxUrl,
        method: 'POST',
        dataType: 'json',
        data: {
          action: 'bhub/templates/form/step/submit',
          _ajax_nonce: i18n.nonce,
          collect: JSON.stringify(this.collect),
          data,
        },
        success: (res) => {
          const { data, success } = res

          if (success) {
            this.stepsEl.append(data.template)
            this.collect.activeStep = data.activeStep
            this.goStep(data.activeStep)
            resolve(res.data)
          } else {
            reject(res.data)
          }
        },
      })
    })
  }
}

export default BhubStepForm
